import { ValidatorInput } from './validation-descriptor.entity';
import { AppConstants } from '../../app-constants.service';
import { PasswordCriteria } from '../../common.component.module/password-criteria';

export class UserValidator {

    static PASSWORD_ERROR_MSG: string = AppConstants.VHV_PASSWORD_ERROR_MSG;

    static validatePw(given: string): boolean {
        const numChars = given.length;
        const pwCorrectNumChars = numChars >= PasswordCriteria.PW_MIN_LENGTH && numChars <= PasswordCriteria.PW_MAX_LENGTH;
        const pwCorrectMajuscule = PasswordCriteria.PW_CRITERIA_MAJUSCULE.test(given);
        const pwCorrectMinuscule = PasswordCriteria.PW_CRITERIA_MINUSCULE.test(given);
        const pwCorrectDigit = PasswordCriteria.PW_CRITERIA_DIGIT.test(given);
        const pwCorrectSpecialChar = PasswordCriteria.PW_CRITERIA_SPECIAL_CHAR.test(given);
        const pwCheckNoOtherChars = PasswordCriteria.PW_CRITERIA_NO_OTHER_CHARS.test(given);

        return pwCorrectNumChars
            && pwCorrectMajuscule
            && pwCorrectMinuscule
            && pwCorrectDigit
            && pwCorrectSpecialChar
            && pwCheckNoOtherChars;
    }

    static validateEmail(given: string): boolean {
        return /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,64})$/.test(given);
    }

    static validateAndDoubleCheckPw(field: ValidatorInput, checkValue: string) {
        field.valid = true;

        if (field.value !== checkValue) {
            field.valid = false;
            field.errorMsg = 'Passwort und Passwort-Wiederholung stimmen nicht &uuml;berein.';
        }

        if (!UserValidator.validatePw(field.value)) {
            field.errorMsg = this.PASSWORD_ERROR_MSG;
            field.valid = false;
        }
    }

    static validateSingleEmail(field: ValidatorInput): boolean {
        field.valid = true;

        if (!UserValidator.validateEmail(field.value)) {
            field.errorMsg = 'Die eingegebene E-Mail-Adresse ist nicht g&uuml;ltig.';
            field.valid = false;
        }

        return field.valid;
    }

    static validateAndDoubleCheckEmail(field: ValidatorInput, checkValue: string): boolean {
        field.valid = true;

        if (UserValidator.isDoubleCheckEmailInvalid(field, checkValue)) {
            field.errorMsg = 'E-Mail-Adresse und E-Mail-Adresse-Wiederholung stimmen nicht &uuml;berein.';
            field.valid = false;
        } else if (!UserValidator.validateEmail(field.value)) {
            field.errorMsg = 'Die eingegebene E-Mail-Adresse ist nicht g&uuml;ltig.';
            field.valid = false;
        }

        return field.valid;
    }

    static isDoubleCheckEmailInvalid(field: ValidatorInput, checkValue: string): boolean {
        if (field.value && checkValue && field.value.toLowerCase() !== checkValue.toLowerCase()) {
            return true;
        } else if (field.value && !checkValue) {
            return true;
        }

        return false;
    }

}
